import { defineStore } from 'pinia'
import { store } from '../index'

interface BizState {
  bizToken: string
  // 2.0 服务账号登录返回的原始用户信息(含 bizRoleDetails/company_id), 供各模块判断公司范围等使用
  bizUserInfo: Record<string, any> | undefined
}

// 2.0(企会家 biz-crm)服务账号 token, 与主账号(userStore)token 完全独立
export const useBizStore = defineStore('biz', {
  state: (): BizState => {
    return {
      bizToken: '',
      bizUserInfo: undefined
    }
  },
  getters: {
    getBizToken(): string {
      return this.bizToken
    },
    getBizUserInfo(): Record<string, any> | undefined {
      return this.bizUserInfo
    }
  },
  actions: {
    setBizToken(bizToken: string) {
      this.bizToken = bizToken
    },
    setBizUserInfo(bizUserInfo: Record<string, any> | undefined) {
      this.bizUserInfo = bizUserInfo
    },
    reset() {
      this.bizToken = ''
      this.bizUserInfo = undefined
    }
  },
  persist: true
})

export const useBizStoreWithOut = () => {
  return useBizStore(store)
}
